import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ProjectVersion } from 'src/app/constants/project-version-constans';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { FormatDetailModel } from 'src/app/models/formats/format-detail.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { TransferStoreWorkshopPrintModel } from 'src/app/models/print/maintenance/transfer-store-workshop-print.model';
import { FormatDetailService } from 'src/app/services/formats/format-detail.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { PrintPageSizeService } from 'src/app/services/global-services/print-page-size.service';

@Component({
  selector: 'app-print-transfer-store-workshop',
  templateUrl: './print-transfer-store-workshop.component.html',
  styleUrls: ['./print-transfer-store-workshop.component.scss'],
  standalone: false
})
export class PrintTransferStoreWorkshopComponent implements OnChanges {

  @Input() companyId: number | null = 0;
  @Input() editFormat: boolean = false;
  @Input() exportFormat: boolean = false;
  @Input() focusText: boolean = false;
  @Input() formatDetail: FormatDetailModel = new FormatDetailModel();
  @Input() reloadPrint: boolean = false;
  @Input() transferStoreWorkshopPrintModel: TransferStoreWorkshopPrintModel = new TransferStoreWorkshopPrintModel();
  @Output() emitFormatDetail = new EventEmitter<FormatDetailModel>();
  @Output() finishLoadingPrint = new EventEmitter<boolean>();

  dateNow: Date = new Date();
  formatModel: FormatModel = new FormatModel();
  listFormatDetailUpdates: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  logoEnterprise: SafeUrl = '';
  version: string = ProjectVersion.projectVersion;
  private keydownListener!: (e: KeyboardEvent) => void;
  private mouseupListener!: () => void;
  private mousemoveListener!: (e: MouseEvent) => void;
  private keyupListener!: (e: KeyboardEvent) => void;

  // Variables para mover elementos
  bottomPreview: number = 0;
  columns: { field: string; header: string; }[] = [];
  idMap: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat: string | null; } } = {
    'articleCode': { id: 'articulo', type: 'text', showTotal: false, printFormat: null },
    'articleName': { id: 'articulo-nombre', type: 'text', showTotal: false, printFormat: null },
    'storeCode': { id: 'bodega', type: 'text', showTotal: false, printFormat: null },
    'quantity': { id: 'cantidad', type: 'decimal', showTotal: true, printFormat: null },
  };
  element: any;
  elementStyle: any;
  id = '';
  isShift = false;
  elementsBody: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  elementsLabel: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  leftPreview: number = 0;
  mouseDown: boolean = false;
  nameEnterprise: string = '';
  newFormatDetail: FormatDetailModel = new FormatDetailModel();
  rightPreview: number = 0;
  shiftX: number = 0;
  shiftY: number = 0;
  speed = 2;
  topPreview: number = 0;

  constructor(private cdr: ChangeDetectorRef,
    private enterpriseService: EnterpriseService,
    private formatService: FormatService,
    private formatDetailService: FormatDetailService,
    private sanitizer: DomSanitizer,
    private printPageSizeService: PrintPageSizeService) { }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const reloadPrint = changes["reloadPrint"];
    const exportFormat = changes["exportFormat"];
    const formatDetail = changes["formatDetail"];
    const transferStoreWorkshopPrintModel = changes["transferStoreWorkshopPrintModel"];

    if (reloadPrint && !reloadPrint.firstChange) {
      if (transferStoreWorkshopPrintModel && !transferStoreWorkshopPrintModel.firstChange) {
        if (this.transferStoreWorkshopPrintModel.enterpriseLogo != null) {
          this.listFormatDetailUpdates = new Array<FormatDetailModel>();
          await this.getLogo(this.transferStoreWorkshopPrintModel.enterpriseLogo);
        } else {
          this.getLogoDefault();
        }
        await this.getFormatByCompanyAndCode();
      }
    }
    if (exportFormat && !exportFormat.firstChange) {
      this.updateRangeFormatDetail();
    }
    if (formatDetail && !formatDetail.firstChange) {
      this.changeFormatDetail();
    }
  }

  ngOnDestroy() {
    this.printPageSizeService.removePageSizeStyle();

    // Remover event listeners globales
    if (this.keydownListener) document.removeEventListener('keydown', this.keydownListener);
    if (this.mouseupListener) document.removeEventListener('mouseup', this.mouseupListener, true);
    if (this.mousemoveListener) document.removeEventListener('mousemove', this.mousemoveListener, true);
    if (this.keyupListener) document.removeEventListener('keyup', this.keyupListener);
  }

  ngAfterViewInit() {
    if (this.editFormat) {
      this.keydownListener = (e: KeyboardEvent) => {
        const target = e.target as HTMLElement;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.tagName === 'SELECT' ||
            target.isContentEditable)
        ) {
          return;
        }
        // 2. Si no hay ningún elemento seleccionado para mover, no bloquear
        if (!this.element) {
          return;
        }

        // Deshabilita desplazamiento del scroll con la tecla espacio y flechas
        if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
          this.blockScrollArrows(e);
        }

        if (e.which == 16) this.isShift = true;
        //Mover element con flechas
        if (!this.isShift) {
          switch (e.key) {
            case 'ArrowLeft': { this.moveLeft(); break; }
            case 'ArrowRight': { this.moveRight(); break; }
            case 'ArrowUp': { this.moveUp(); break; }
            case 'ArrowDown': { this.moveDown(); break; }
          }
        }

        //Modificar element tamaño de objeto
        if (this.isShift) {
          switch (e.which) {
            case 37: { this.decreaseWidth(); break; }
            case 38: { this.decreaseHeight(); break; }
            case 39: { this.increaseWidth(); break; }
            case 40: { this.increaseHeight(); break; }
          }
        }
      };

      this.mouseupListener = () => {
        this.onMouseUp();
      };

      this.mousemoveListener = (e: MouseEvent) => {
        this.onMouseMove(e);
      };

      this.keyupListener = (e: KeyboardEvent) => {
        if (e.which == 16) this.isShift = false;
      };

      // Registrar los listeners en el document
      document.addEventListener('keydown', this.keydownListener);
      document.addEventListener('mouseup', this.mouseupListener, true);
      document.addEventListener('mousemove', this.mousemoveListener, true);
      document.addEventListener('keyup', this.keyupListener);
    }
  }

  private adjustElementSize(property: 'height' | 'width', delta: number) {
    if (this.focusText) {
      return;
    }
    const currentValue = this.elementStyle.getPropertyValue(property);
    const numericValue = parseFloat(currentValue.replace('px', ''));
    const newValue = numericValue + delta;
    this.element.style[property] = `${newValue}px`;
    this.onClick();
  }

  private async applyColumnStyles(transferStoreWorkshopPrintModel: TransferStoreWorkshopPrintModel) {
    for (const column of this.columns.map(x => x.field)) {
      const element = this.elementsBody.find(x => x.description === column);
      if (!element) {
        continue;
      }
      this.element = document.getElementById(`${element.name}-${transferStoreWorkshopPrintModel.transferStoreWorkshopId}`);
      if (this.element) {
        this.element.style.fontSize = `${element.fontSize}px`;
        this.element.style.width = `${element.width}%`;
        this.changeAlignment(element.alignment);
      }
    }
  }

  private applyElementStyles(element: FormatDetailModel) {
    if (!element.visible) {
      this.element!.setAttribute('hidden', '');
      return;
    }

    const style = this.element!.style;
    style.fontSize = `${element.fontSize}px`;
    this.changeAlignment(element.alignment);
    this.changeBold(element.bold);
    this.changeBorder(element.border);

    if (element.name.includes('foot-')) {
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    } else {
      style.backgroundColor = 'transparent';
      style.position = 'absolute';
      style.left = `${element.left}%`;
      style.top = `${element.top}%`;
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    }
  }

  private applyHeaderFooterHeights(orderId: number, formatModel: FormatModel) {
    setTimeout(async () => {
      const head = document.getElementById(`head-${orderId}`);
      head!.style.height = `${formatModel.head}px`;
      const foot = document.getElementById(`foot-${orderId}`);
      foot!.style.height = `${formatModel.foot}px`;
    }, 200);
  }

  private applyFormatDetails(elements: FormatDetailModel[], transferStoreWorkshopPrintModel: TransferStoreWorkshopPrintModel) {
    for (const element of elements) {
      if (element.band === 'body') {
        continue;
      }
      setTimeout(async () => {
        this.element = document.getElementById(`${element.name}-${transferStoreWorkshopPrintModel.transferStoreWorkshopId}`);
        if (this.element) {
          this.applyElementStyles(element);
        }
      }, 200);
    }
  }

  private applyFormatStyles(element: HTMLElement) {
    element.style.fontSize = `${this.formatDetail.fontSize}px`;
    this.changeAlignment(this.formatDetail.alignment);
    this.changeBold(this.formatDetail.bold);
    this.changeBorder(this.formatDetail.border);
    if (!this.formatDetail.name.includes('foot-')) {
      element.style.position = 'absolute';
      element.style.left = `${this.formatDetail.left}%`;
      element.style.top = `${this.formatDetail.top}%`;
    }
    element.style.height = `${this.formatDetail.height}px`;
    element.style.width = `${this.formatDetail.width}px`;
  }

  private applyParagraphStyles(transferStoreWorkshopPrintModel: TransferStoreWorkshopPrintModel) {
    this.elementsBody.filter(x => x.type === 'p').forEach(element => {
      transferStoreWorkshopPrintModel.transferStoreWorkshopDetails!.forEach(detail => {
        const id = element.name.includes("footer") ? detail.transferStoreWorkshopId : detail.transferStoreWorkshopDetailId;
        this.element = document.getElementById(`${element.name}-${id}`);
        if (this.element) {
          this.element.style.fontSize = `${element.fontSize}px`;
          this.changeAlignment(element.alignment);
          this.changeBold(element.bold);
        }
      });
    });
  }

  blockScrollArrows(e: any) {
    if (!this.focusText) {
      e.preventDefault();
    }
  }

  private buildDisplayedColumns() {
    this.columns = [];
    this.elementsBody.filter(x => x.type === 'label').forEach(element => {
      this.columns.push({ field: element.description!, header: element.text! });
      this.idMap[element.description!].printFormat = element.printFormat ?? null;
    });
  }

  changeAlignment(alignment: string) {
    this.element.style.textAlign = alignment;
  }

  changeBold(bold: string) {
    this.element.style.fontWeight = bold;
  }

  changeBorder(border: string) {
    switch (border) {
      case 'noborder': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        break;
      }
      case 'border': {
        this.element.style.border = '1px solid rgb(0, 0, 0)';
        break;
      }
      case 'underline': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        this.element.style.borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }
  }

  async chargeFormat(formatModel: FormatModel): Promise<boolean> {
    return new Promise((resolved) => {
      this.formatModel = formatModel;
      this.printPageSizeService.setPageSizeStyle(formatModel.paperSizeId);
      this.applyHeaderFooterHeights(this.transferStoreWorkshopPrintModel.transferStoreWorkshopId!, formatModel);
      this.extractFormatDetails(formatModel);
      this.buildDisplayedColumns();
      this.applyFormatDetails(formatModel.formatDetails, this.transferStoreWorkshopPrintModel);
      setTimeout(async () => {
        await this.applyColumnStyles(this.transferStoreWorkshopPrintModel);
        this.applyParagraphStyles(this.transferStoreWorkshopPrintModel);
        resolved(true);
      }, 200);
    });
  }

  changeFormatDetail() {
    const formatDetailId = this.formatDetail.formatDetailId;
    if (formatDetailId == 0) return;
    const isBody = this.formatDetail.band === 'body';
    const isLabel = this.formatDetail.type === 'label';
    if (isBody) {
      const element = this.elementsBody.find(x => x.formatDetailId === formatDetailId);
      if (!element) {
        return;
      }
      element.alignment = this.formatDetail.alignment;
      element.fontSize = this.formatDetail.fontSize;
      if (isLabel) {
        element.visible = this.formatDetail.visible;
        element.width = this.formatDetail.width;
        element.text = this.formatDetail.text;
        element.printFormat = this.formatDetail.printFormat;
        if (!this.formatDetail.visible) {
          this.columns = this.columns.filter(x => x.field !== element.description);
        } else {
          this.updateElementWidth(this.formatDetail.name, this.transferStoreWorkshopPrintModel.transferStoreWorkshopId!);
          this.updateElementStyle(this.formatDetail.name, this.transferStoreWorkshopPrintModel.transferStoreWorkshopId!);
          this.changeAlignment(this.formatDetail.alignment);
        }
      } else {
        element.bold = this.formatDetail.bold;
        this.transferStoreWorkshopPrintModel.transferStoreWorkshopDetails!.forEach(detail => {
          if (detail.transferStoreWorkshopDetailId) {
            const id = this.formatDetail.name.includes("footer") ? detail.transferStoreWorkshopId : detail.transferStoreWorkshopDetailId;
            this.updateElementStyle(this.formatDetail.name, id);
            this.changeAlignment(this.formatDetail.alignment);
            this.changeBold(this.formatDetail.bold);
          }
        });
      }
      this.elementsBody = this.elementsBody.filter(x => x.formatDetailId !== formatDetailId);
      this.elementsBody.push(element);
      const fieldName = element.description;
      if (fieldName && this.idMap[fieldName]) {
        this.idMap[fieldName].printFormat = element.printFormat;
      }
    } else {
      this.updateElementStyle(this.formatDetail.name, this.transferStoreWorkshopPrintModel.transferStoreWorkshopId!);

      if (!this.formatDetail.visible) {
        this.element.setAttribute('hidden', '');
      } else {
        this.applyFormatStyles(this.element);
        this.updateLabelText(formatDetailId, this.formatDetail.text!);
        this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== formatDetailId);
        this.listFormatDetailUpdates.push(this.formatDetail);
      }
    }
  }

  clickTable(event: any) {
    if (!this.editFormat) {
      return;
    }

    const element = document.getElementById(event.target.id);
    if (!element) {
      return;
    }

    const elementStyle = window.getComputedStyle(element);
    const name = event.target.id.substring(0, event.target.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    const bodyElement = this.elementsBody.find(x => x.name === name);

    if (!formatDetail || !bodyElement) {
      return;
    }

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.type = formatDetail.type;
    this.newFormatDetail.visible = bodyElement.visible;
    this.newFormatDetail.text = bodyElement.text;
    this.newFormatDetail.orderTable = bodyElement.orderTable;
    this.newFormatDetail.printFormat = bodyElement.printFormat;
    if (formatDetail.type === 'label') {
      const rawWidth = element.style.width;
      const width = parseFloat(rawWidth.replace('%', '')) || 0;
      this.newFormatDetail.width = parseFloat(width.toFixed(4));
    } else {
      this.newFormatDetail.width = 0;
    }
    const fontSize = parseInt(elementStyle.getPropertyValue('font-size').replace('px', ''));
    this.newFormatDetail.fontSize = isNaN(fontSize) ? 0 : fontSize;
    const fontWeight = elementStyle.getPropertyValue('font-weight');
    this.newFormatDetail.bold = fontWeight === '400' ? 'normal' : 'bold';
    this.newFormatDetail.alignment = elementStyle.getPropertyValue('text-align');

    this.emitFormatDetail.emit(this.newFormatDetail);
  }

  decreaseHeight() {
    this.adjustElementSize('height', -this.speed);
  }

  decreaseWidth() {
    this.adjustElementSize('width', -this.speed);
  }

  onColumnReorder(columns: { field: string; header: string; }[]) {
    columns.forEach((col, index) => {
      this.elementsBody.find(x => x.description == col.field)!.orderTable = index;
    });
  }

  private extractFormatDetails(formatModel: FormatModel) {
    this.elementsLabel = formatModel.formatDetails.filter(x => x.type === 'label');
    this.elementsBody = formatModel.formatDetails
      .filter(x => x.band === 'body' && x.visible)
      .sort((a, b) => a.orderTable - b.orderTable);
  }

  private getBorderStyle(): string {
    if (this.elementStyle.getPropertyValue('border')) {
      if (this.elementStyle.getPropertyValue('border') === '0px none rgb(0, 0, 0)') {
        return 'noborder';
      } else {
        return 'border';
      }
    } else {
      return 'underline';
    }
  }

  async getFormatByCompanyAndCode() {
    const promises: any = [];
    if (this.companyId != null && this.companyId != 0) {
      this.transferStoreWorkshopPrintModel.transferStoreWorkshopDetails!.forEach((detail, index) => {
        index += 1;
        detail.index = index;
      });
      try {
        const response = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId, FormatsEnums.transferStoreWorkshop));
        Promise.all(promises).then(async () => {
          await this.chargeFormat(response);
          this.cdr.detectChanges();
          requestAnimationFrame(() => {
            this.finishLoadingPrint.emit(true);
          });
        });
      } catch (error) {
        console.error('Error al obtener el formato por empresa y código.', error);
      }
    }
  }

  async getLogo(enterpriseLogo: string) {
    let blob: Blob | null = null;
    try {
      blob = await firstValueFrom(this.enterpriseService.getEnterpriseLogoAsync(enterpriseLogo));
      if (blob) {
        this.logoEnterprise = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
      }
    } catch (error) {
      console.error('Error al obtener el logo de la empresa.', error);
    }
  }

  async getLogoDefault() {
    const logoPath = 'assets/images/icons/logo-empty.png';
    this.logoEnterprise = this.sanitizer.bypassSecurityTrustUrl(logoPath);
  }

  private getStylePx(property: string): number {
    return parseFloat(this.elementStyle.getPropertyValue(property).replace('px', '')) || 0;
  }

  private getStylePxValue(property: string): number {
    const value = this.elementStyle.getPropertyValue(property);
    return parseFloat(value.replace('px', '')) || 0;
  }

  increaseHeight() {
    this.adjustElementSize('height', this.speed);
  }

  increaseWidth() {
    this.adjustElementSize('width', this.speed);
  }

  moveDown() {
    this.moveElement('top', this.speed, this.bottomPreview, true);
  }

  private moveElement(direction: 'top' | 'left', delta: number, previewLimit: number, isVertical: boolean) {
    if (this.focusText || !this.elementStyle) {
      return;
    }

    const currentValue = this.elementStyle.getPropertyValue(direction);
    let position = parseFloat(currentValue.replace('px', ''));
    position += delta;
    const sizeProp = isVertical ? 'height' : 'width';
    const size = parseFloat(this.elementStyle.getPropertyValue(sizeProp).replace('px', ''));
    if (position < 0) {
      position = 0;
    }
    if (position + size > previewLimit) {
      position = previewLimit - size;
    }
    const percentage = ((position / previewLimit) * 100).toFixed(4);
    this.element.style[direction] = `${percentage}%`;

    this.onClick();
  }

  moveLeft() {
    this.moveElement('left', -this.speed, this.rightPreview, false);
  }

  moveRight() {
    this.moveElement('left', this.speed, this.rightPreview, false);
  }

  moveUp() {
    this.moveElement('top', -this.speed, this.bottomPreview, true);
  }

  onClick() {
    if (!this.editFormat) {
      return;
    }

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) {
      return;
    }

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.text = formatDetail.text;
    this.newFormatDetail.visible = true;
    this.newFormatDetail.printFormat = formatDetail.printFormat;

    this.newFormatDetail.fontSize = this.getStylePxValue('font-size');
    this.newFormatDetail.bold = this.elementStyle.getPropertyValue('font-weight') === '400' ? 'normal' : 'bold';
    this.newFormatDetail.alignment = this.elementStyle.getPropertyValue('text-align');
    this.newFormatDetail.border = this.getBorderStyle();

    if (!name.includes('foot-')) {
      this.newFormatDetail.left = parseFloat(((this.getStylePxValue('left') / this.rightPreview) * 100).toFixed(4));
      this.newFormatDetail.top = parseFloat(((this.getStylePxValue('top') / this.bottomPreview) * 100).toFixed(4));
    }

    this.newFormatDetail.width = parseFloat(this.getStylePxValue('width').toFixed(4));
    this.newFormatDetail.height = parseFloat(this.getStylePxValue('height').toFixed(4));

    this.emitFormatDetail.emit(this.newFormatDetail);
    this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== this.newFormatDetail.formatDetailId);
    this.listFormatDetailUpdates.push(this.newFormatDetail);
  }

  onDragStart() {
    return false;
  }

  onMouseDown(event: any) {
    if (!this.editFormat) {
      return;
    }

    if (this.element) {
      this.element.style.backgroundColor = 'transparent';
    }

    this.mouseDown = true;
    this.id = event.target.id;
    this.element = document.getElementById(this.id);
    if (!this.element) {
      return;
    }

    this.elementStyle = window.getComputedStyle(this.element);
    this.element.style.backgroundColor = '#0d6efd6e';

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) {
      return;
    }

    const relativeElement = document.getElementById(`${formatDetail.band}-${this.transferStoreWorkshopPrintModel.transferStoreWorkshopId}`);
    if (!relativeElement) {
      return;
    }

    const relativeStyle = window.getComputedStyle(relativeElement);

    this.leftPreview = Math.round(relativeElement.offsetLeft - relativeElement.scrollLeft);
    this.topPreview = Math.round(relativeElement.offsetTop - relativeElement.scrollTop);
    this.rightPreview = parseInt(relativeStyle.width.replace('px', ''));
    this.bottomPreview = parseInt(relativeStyle.height.replace('px', ''));

    this.element.style.cursor = 'move';
    const leftPX = event.pageX - this.leftPreview;
    const topPX = event.pageY - this.topPreview;
    this.shiftX = leftPX - this.getStylePx('left');
    this.shiftY = topPX - this.getStylePx('top');

    this.onClick();
  }

  onMouseMove(event: any) {
    if (!this.mouseDown || this.id.includes('foot-')) return;

    this.element.style.position = 'absolute';
    const leftPx = Math.max(0, event.pageX - this.leftPreview - this.shiftX);
    const widthPx = this.getStylePx('width');
    const finalLeft = Math.min(leftPx, this.rightPreview - widthPx);
    const topPx = Math.max(0, event.pageY - this.topPreview - this.shiftY);
    const heightPx = this.getStylePx('height');
    const finalTop = Math.min(topPx, this.bottomPreview - heightPx);

    this.updateElementPosition(finalLeft, finalTop);
    this.onClick();
  }

  onMouseUp() {
    this.mouseDown = false;
  }

  private updateElementWidth(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) {
      return;
    }
    this.element.style.width = `${this.formatDetail.width}%`;
  }

  private updateLabelText(formatId: number, text: string) {
    const labelElement = this.elementsLabel.find(x => x.formatDetailId === formatId);
    if (labelElement) {
      labelElement.text = text;
    }
  }

  private updateElementPosition(leftPx: number, topPx: number) {
    const leftPercentage = ((leftPx / this.rightPreview) * 100).toFixed(4);
    const topPercentage = ((topPx / this.bottomPreview) * 100).toFixed(4);
    this.element.style.left = `${leftPercentage}%`;
    this.element.style.top = `${topPercentage}%`;
  }

  private updateElementStyle(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) {
      return;
    }
    this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
  }

  async updateRangeFormatDetail() {
    try {
      this.elementsBody.forEach(element => {
        this.listFormatDetailUpdates.push(element);
      });
      const response = await firstValueFrom(this.formatDetailService.updateRangeFormatDetail(this.listFormatDetailUpdates));
      this.chargeFormat(response);
    } catch (error) {
      console.error('Error updating format details:', error);
    }
  }
}
